import ApplicationAdapter from "./application";

export default class FileStorageVolumeAdapter extends ApplicationAdapter {
  urlForQueryRecord() {
    return `${this.apiBaseUri}/filestorage/volumedetails`;
  }

  urlForCreateRecord() {
    return `${this.apiBaseUri}/filestorage/createvolume`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/filestorage/editvolume?volumeid=${id}`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    return `${this.apiBaseUri}/filestorage/deletevolume?volumeid=${id}&projectkey=${snapshot.belongsTo("project").id}`;
  }
}
